module.exports = __webpack_public_path__ + "img/abroad_logo_cn.png.f0594c32.png";